import BaseClient from '@/app/model/api/response/baseApiClient'

class AccountDetailApi extends BaseClient {
  public getAccountDetail (id: string) {
    const path = '/v1/master/users/' + id
    const url = new URL(process.env.VUE_APP_API_URL + path)

    /* 共通処理 */
    return super.doFetch(decodeURI(url.href), 'GET')
  }
}

export default new AccountDetailApi()
